<template>
    <section class="user-table">
        <el-table
            :data="items"
            :default-sort="{ prop: sort_by }"
            style="width: 100%"
            empty-text="No Users"
            @row-click="handleClick"
            @sort-change="handleSortChange">
            <el-table-column 
                :sortable="sortable" 
                prop="first_name"
                min-width="110px" 
                label="First Name">
                <template slot-scope="scope">
                    <div
                        :aria-label="'User: '+ scope.row.first_name"
                        tabindex="0"
                        @keyup.enter="navigateToUserDetail(scope.row)">{{ scope.row.first_name }}</div>
                </template>
            </el-table-column>
            <el-table-column 
                prop="last_name" 
                label="Last Name" 
                min-width="100px"
                sortable />
            <el-table-column v-if="showColumn('email')" 
                             prop="email" 
                             label="Email" 
                             sortable />
            <el-table-column v-if="showColumn('role')" 
                             prop="role.display_name" 
                             min-width="100px" 
                             label="Role" />
            <el-table-column
                v-if="showColumn('assignments')"
                prop="assignments"
                label="Assignments"
                min-width="150px" >
                <template slot-scope="scope">{{ assignments(scope.row) }}</template>
            </el-table-column>
            <el-table-column v-if="showColumn('active')" 
                             label="State" 
                             width="75px" 
                             align="right">
                <template slot-scope="scope">
                    <app-tag v-if="!scope.row.active" 
                             slot="tag" 
                             type="danger" 
                             size="tiny">Pending</app-tag>
                </template>
            </el-table-column>

            <slot name="actions"/>
        </el-table>
    </section>
</template>

<script>
export default {
    name: 'user-table',
    components: {},
    props: {
        items: {
            type: Array,
            default() {
                return []
            }
        },
        sort_by: String,
        columns: {
            type: Array,
            default() {
                return [
                    'first_name',
                    'last_name',
                    'email',
                    'role',
                    'assignments'
                ]
            }
        },
        allowSort: {
            type: Boolean,
            default: true
        },
        remoteSort: {
            type: Boolean,
            default: true
        },
        handleClick: {
            default() {
                return user => {
                    this.$router.push({
                        name: 'users.detail',
                        params: { id: user.id }
                    })
                }
            }
        }
    },
    computed: {
        sortable() {
            return this.allowSort ? (this.remoteSort ? 'custom' : true) : false
        },
        users() {
            let users = this.includeAssignments(this.items)
            return users
        }
    },
    methods: {
        navigateToUserDetail(event) {
            this.handleClick(event)
            return false
        },
        handleSortChange(properties) {
            this.$emit('sort-change', properties)
        },
        showColumn(column) {
            return this.columns.indexOf(column) >= 0
        },
        assignments(user) {
            const items = [ 
                ...user.assignedCourses.map((item) => item.title),
                ...user.assignedTeams.map((item) => item.name),
                ...user.assignedEvents.map((item) => item.title)
            ]
            if (items.length <= 0) return '–'
            var str = items.sort().slice(0, 3).join(', ')
            let remainder = items.length - 3
            str += remainder > 0 ? '... (+' + remainder + ')' : ''
            return str
        }
    }
}
</script>

<style lang="stylus"></style>
